import {useHttp} from "./http.hook";
import {CountryExchange} from "../shared/countryExchange";

interface IDataGetAll {
  message: string,
  info: string[]
}

export const useTickerList = () => {

  const {loading, request, error, clearError} = useHttp()

  //получение полного списка инструментов с ru.investing.com, по которым будем торговать
  const getTickers = async (country: CountryExchange) => {
    try {
      const data: IDataGetAll = await request('/api/tickers/get-ticker-list', 'POST', {
        country: country
      })
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных. Выберите страну еще раз!')
    }
  }

  return {loading, getTickers, error, clearError}
}